import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notifications: [],
  loadingNotifications: false,
};

const softwareNotificationSlice = createSlice({
  name: "softwareNotification",
  initialState,
  reducers: {
    loadingNotifications(state) {
      state.loadingNotifications = true;
    },
    loadingNotificationsDone(state) {
      state.loadingNotifications = false;
    },
    setNotifications(state, action) {
      state.notifications = action.payload;
    },
  },
});

export const {
  loadingNotifications,
  loadingNotificationsDone,
  setNotifications,
} = softwareNotificationSlice.actions;

export default softwareNotificationSlice.reducer;
